import comp from "./FeatureCard";
export default comp;
